var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "custom-select",
      class: { open: _vm.open },
      attrs: { tabindex: "0" },
      on: {
        focus: function ($event) {
          return _vm.activate()
        },
        blur: function ($event) {
          return _vm.deactivate()
        },
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.selectPrevOption()
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown",
              ])
            ) {
              return null
            }
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.selectNextOption()
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            $event.stopPropagation()
            return _vm.deactivate()
          },
        ],
      },
    },
    [
      _c(
        "select",
        _vm._b(
          {
            attrs: { tabindex: "-1" },
            on: {
              change: function ($event) {
                return _vm.onChange($event.target.value)
              },
            },
          },
          "select",
          _vm.$attrs,
          false
        ),
        _vm._l(_vm.options, function (option) {
          return _c("option", {
            domProps: {
              selected: _vm.getOptionValue(option) === _vm.value,
              value: _vm.getOptionValue(option),
              innerHTML: _vm._s(_vm.getOptionLabel(option)),
            },
          })
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "custom-select-trigger" }, [
        _c(
          "div",
          [
            _c("transition", [
              _c("span", {
                key: _vm.getValueLabel(_vm.value),
                domProps: { innerHTML: _vm._s(_vm.getValueLabel(_vm.value)) },
              }),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("transition", [
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open",
              },
            ],
            staticClass: "custom-select-options",
          },
          _vm._l(_vm.options, function (option) {
            return _c("li", {
              staticClass: "custom-select-option",
              class: { selected: _vm.isSelected(option) },
              domProps: { innerHTML: _vm._s(_vm.getOptionLabel(option)) },
              on: {
                click: function ($event) {
                  _vm.onChange(_vm.getOptionValue(option))
                },
              },
            })
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }